const iconButtonSizeDecorator = (size, style, theme) => {
  switch (size) {
    case 'large':
    case 'lg':
      return {
        ...style,
        padding: theme.tokens.ComponentIconBtnSizeLargePadding,
        fontSize: theme.tokens.ComponentIconBtnSizeLargeFontSize,
        lineHeight: theme.tokens.ComponentIconBtnSizeLargeLineHeight,
        borderRadius: theme.tokens.ComponentIconBtnSizeLargeBorderRadius,
        height: theme.tokens.ComponentIconBtnSizeLargeHeight,
        width: theme.tokens.ComponentIconBtnSizeLargeWidth,
        '& svg': {
          fontSize: theme.tokens.ComponentIconBtnSizeLargeFontSize
        }
      };
    case 'small':
    case 'sm':
      return {
        ...style,
        padding: theme.tokens.ComponentIconBtnSizeSmallPadding,
        fontSize: theme.tokens.ComponentIconBtnSizeSmallFontSize,
        lineHeight: theme.tokens.ComponentIconBtnSizeSmallLineHeight,
        borderRadius: theme.tokens.ComponentIconBtnSizeSmallBorderRadius,
        height: theme.tokens.ComponentIconBtnSizeSmallHeight,
        width: theme.tokens.ComponentIconBtnSizeSmallWidth,
        '& svg': {
          fontSize: theme.tokens.ComponentIconBtnSizeSmallFontSize
        }
      };
    case 'aux':
      return {
        ...style,
        padding: theme.tokens.ComponentBtnSizeAuxPadding,
        fontSize: theme.tokens.ComponentBtnSizeAuxFontSize,
        fontWeight: theme.tokens.ComponentBtnSizeAuxFontWeight,
        lineHeight: theme.tokens.ComponentBtnSizeAuxLineHeight,
        borderRadius: theme.tokens.ComponentBtnSizeAuxBorderRadius,
        height: theme.tokens.ComponentBtnSizeAuxHeight
      };
    case 'medium':
    case 'md':
    default:
      return {
        ...style,
        padding: theme.tokens.ComponentIconBtnSizeDefaultPadding,
        fontSize: theme.tokens.ComponentIconBtnSizeDefaultFontSize,
        lineHeight: theme.tokens.ComponentIconBtnSizeDefaultLineHeight,
        borderRadius: theme.tokens.ComponentIconBtnSizeDefaultBorderRadius,
        height: theme.tokens.ComponentIconBtnSizeDefaultHeight,
        width: theme.tokens.ComponentIconBtnSizeDefaultWidth,
        '& svg': {
          fontSize: theme.tokens.ComponentIconBtnSizeDefaultFontSize
        }
      };
  }
};
export default iconButtonSizeDecorator;